import { getWallesterCardDatas } from "@/store/api"
import Spinner from "@/components/spinner/spinner.vue"
import { getDateToExpirationFormat } from "@/helpers/date.js"
import CardContentWallester from "./card-content-wallester/card-content-wallester.vue"
export default {
  name: "CardItemWallester",
  components: { Spinner, CardContentWallester },
  props: {
    card: { type: Object, defaut: () => {} }
  },
  data () {
    return {
      loading: true,
      /* logo:
        "data:image/svg+xml;base64,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",
      */
      displayedCard: {
        number: "",
        cvv: "",
        expiration: "",
        secret: 0

      },

      keys: {
        publicKey: {},
        privateKey: {}
      },
      flipped: false,
      copyAlert: false,
      copyAlertTimeout: 3000,
      showHelp: false
    }
  },
  created () {},
  computed: {},

  async mounted () {
    await this.setCardsInfos()
  },
  emits: ['error'],
  methods: {
    async setCardsInfos () {
      this.keys = await this.generateKeys()

      const exportedPubKey = await this.exportPublicKey()

      const response = await getWallesterCardDatas(
        { id: this.card.id, publicKey: exportedPubKey },
        {}
      ).catch(error => {
        this.$emit("error")
        this.loading = false
      })

      console.log("Get wallester card data ", response.data)

      this.displayedCard = await this.decode(response.data.encrypted)
      this.displayedCard.expiration = getDateToExpirationFormat(
        response.data.expiry
      )
      this.displayedCard.secret = await this.decodeSecret(response.data.secret)
      this.loading = false
      this.flipped = true
    },
    /**
     *  generate two keys (private / public)
     * @returns Promise
     */
    generateKeys () {
      return window.crypto.subtle.generateKey(
        {
          name: "RSA-OAEP",
          modulusLength: 4096,
          publicExponent: new Uint8Array([0x01, 0x00, 0x01]),
          hash: { name: "SHA-256" }
        },
        true,
        ["decrypt"]
      )
    },

    /**
     * export the public key in good format RSA
     * @returns {string} base64 encoded key
     */
    async exportPublicKey () {
      const exported = await window.crypto.subtle.exportKey(
        "spki",
        this.keys.publicKey
      )

      const exportedAsString = this._ab2str(exported)
      const exportedAsBase64 = window.btoa(exportedAsString)
      const pemExported = `-----BEGIN PUBLIC KEY-----\n${exportedAsBase64}\n-----END PUBLIC KEY-----`
      // console.log("** export ** key pem ", pemExported);
      return pemExported
    },

    /**
     * decode string response to get card infos
     * @param {string} string to decode
     * @returns {object} cardToDisplay
     */
    async decode (encryptedString) {
      const enc = new TextEncoder()
      const dec = new TextDecoder()
      const encrypted = encryptedString.split("----------card--------")

      const fromBase64 = base64String =>
        Uint8Array.from(window.atob(base64String), c => c.charCodeAt(0))

      // decode CVV
      const encryptedCardCVV = fromBase64(
        encrypted[0]
          .replace("----------cvv--------\n-----BEGIN CVV2 MESSAGE-----\n", "")
          .replace("\n-----END CVV2 MESSAGE-----\n\n+", "")
      )

      // console.log("ENCRYPTED CARD CVV",    encryptedCardCVV,   enc.encode("CVV2"));

      const cardCvv = await window.crypto.subtle.decrypt(
        {
          name: "RSA-OAEP",
          label: enc.encode("CVV2")
        },
        this.keys.privateKey,
        encryptedCardCVV
      )

      // console.log("cardcvv decrypted:", dec.decode(new Uint8Array(cardCvv)))

      // decode card Number
      const encryptedCardNum = fromBase64(
        encrypted[1]
          .replace("\n-----BEGIN CardNumber MESSAGE-----\n", "")
          .replace("\n-----END CardNumber MESSAGE-----\n", "")
      )

      //  console.log( "ENCRYPTED CARD NUMBER : ",encryptedCardNum,  enc.encode("CardNumber") );

      const cardNum = await window.crypto.subtle.decrypt(
        {
          name: "RSA-OAEP",
          label: enc.encode("CardNumber")
        },
        this.keys.privateKey,
        encryptedCardNum
      )

      //  console.log('cardcvv decrypted:', dec.decode(new Uint8Array(cardNum)));

      return {
        number: dec.decode(new Uint8Array(cardNum)),
        cvv: dec.decode(new Uint8Array(cardCvv))
      }
    },

    async decodeSecret (encryptedString) {
      const enc = new TextEncoder()
      const dec = new TextDecoder()

      const fromBase64 = base64String =>
        Uint8Array.from(window.atob(base64String), c => c.charCodeAt(0))

      // decode CVV
      const secret = fromBase64(encryptedString)

      // console.log("ENCRYPTED CARD CVV", secret);

      const decryptedSecret = await window.crypto.subtle.decrypt(
        {
          name: "RSA-OAEP"
        },
        this.keys.privateKey,
        secret
      )

      // console.log("secret decrypted:", dec.decode(new Uint8Array(decryptedSecret)));

      return dec.decode(new Uint8Array(decryptedSecret))
    },

    copyCardNum () {
      navigator.clipboard.writeText(this.displayedCard.number).then(
        () => {
          console.log("card num copié ", this.displayedCard.number)
          this.showAlert(this.$t("card.copyAlert"))
        },
        () => {
          console.error("card num copy failed ", this.displayedCard.number)
          this.showAlert(false)
          /* clipboard write failed */
        }
      )
    },
    copyCardSecret () {
      navigator.clipboard.writeText(this.displayedCard.secret).then(
        () => {
          console.log("card secret copié ", this.displayedCard.secret)
          this.showAlert(this.$t("card.copyAlert"))
        },
        () => {
          console.error("card secret failed ")
          this.showAlert(false)
          /* clipboard write failed */
        }
      )
    },

    showAlert (text) {
      if (text) {
        this.copyAlert = text
        const to = setTimeout(() => {
          this.copyAlert = false
          clearTimeout(to)
        }, this.copyAlertTimeout)
      } else {
        this.copyAlert = false
      }
    },




    /** UTILITIES */

    /* array buffer to string */
    _ab2str (buf) {
      return String.fromCharCode.apply(null, new Uint8Array(buf))
    }
  }
}
